module.exports = __webpack_public_path__ + "static/media/3.09ef73c1.JPG";